<template>
  <a @click="setLocale($i18n.locale  === 'en' ? 'fr' : 'en')">{{ $i18n.locale  === 'en' ? 'Français' : 'English' }}</a>
</template>

<script>
export default {
  name: 'locale-changer',
  methods: {
    setLocale (locale) {
      this.$i18n.locale = locale
      window.localStorage.setItem('lang', locale)
    }
  }
}
</script>
<style scoped>
a {
  cursor: pointer;
}
</style>
